import { render, staticRenderFns } from "./guard_witness_list.vue?vue&type=template&id=48f99ea7&scoped=true"
import script from "./guard_witness_list.vue?vue&type=script&lang=js"
export * from "./guard_witness_list.vue?vue&type=script&lang=js"
import style0 from "./guard_witness_list.vue?vue&type=style&index=0&id=48f99ea7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f99ea7",
  null
  
)

export default component.exports